// Aba Reuniões (decks): master + gerentes + contas liberadas (06/10/2026,
// pedido do dono: "libere o acesso à aba reuniões para gerente e Narciso").
// Contas do Narciso: barbeiro Moema e o acesso administrativo ativo.
export const REUNIOES_CONTAS = new Set(['user-narciso-moema', 'user-1779206854393']);
export function podeReunioes(user, isGerente) {
  return !!isGerente || (typeof user?.id === 'string' && REUNIOES_CONTAS.has(user.id));
}
